import { BaseFetch } from "../main-model"
export default class EventModel extends BaseFetch {
    getEventBy = (data) =>
    this.authFetch({
      url: "event/getEventBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEventById = (data) =>
    this.authFetch({
      url: "event/getEventById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertEvent = (data) =>
    this.authFetch({
      url: "event/insertEvent",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateEventById = (data) =>
    this.authFetch({
      url: "event/updateEventById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteEventById = (data) =>
    this.authFetch({
      url: "event/deleteEventById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
